import type { Issue } from '../api/types'
import { keyBetween } from '../sortKey'
import { compareKeys } from './filters'
import type { SortMode } from './view'

export function keyForIndex(keys: readonly string[], index: number): string | null {
  const lower = keys[index - 1] ?? null
  const upper = keys[index] ?? null
  if (lower !== null && upper !== null && lower >= upper) return null
  return keyBetween(lower, upper)
}
/** The board column an issue is in, as the server keeps it: its own column's id, else its state. */
const placeKey = (issue: Issue) => issue.column ?? issue.state
export function sortKeyForDrop({ issueId, place, orderedIds, mode, issues }: {
  issueId: string; place: string; orderedIds: readonly string[]; mode: SortMode; issues: ReadonlyMap<string, Issue>
}): string | null {
  if (mode === 'manual') {
    const index = orderedIds.indexOf(issueId)
    if (index < 0) return null
    const project = issues.get(issueId)?.project
    const neighbours = orderedIds.filter(id => id !== issueId)
    if (neighbours.some(id => {
      const issue = issues.get(id)
      return !issue || issue.project !== project || placeKey(issue) !== place
    })) return null
    const keys = neighbours.map(id => issues.get(id)!.sort_key)
    return keyForIndex(keys, index)
  }
  const project = issues.get(issueId)?.project
  const keys = [...issues.values()].filter(i => i.project === project && placeKey(i) === place && i.id !== issueId).map(i => i.sort_key).sort(compareKeys)
  return keyForIndex(keys, 0)
}
